export default __webpack_public_path__ + "static/media/colorfulBlustreamLogo.c1eb4391.svg";